export default "__VITE_ASSET__4d692527__"